import { useSearchParams } from 'react-router-dom';

import { c } from 'ttag';

import { AppName, appUrl } from '@freelancelabs/shared';

export interface ReturnTarget {
    /** L'adresse de l'application d'ou la personne vient. */
    href: string;
    /** « Retour au portail » ou « Retour au back-office ». */
    label: string;
}

/**
 * OU LE RETOUR RAMENE, et pourquoi cet ecran peut le savoir depuis PCG-304.
 *
 * `account` ne pouvait pas le savoir : les deux produits envoyaient vers un lien NU,
 * `redirect-after-login` est consommee au premier depart, et la liste des portees de
 * `RedirectMiddleware` repond « cette personne a-t-elle le droit de se connecter » et
 * jamais « a quelle application », son propre commentaire le disant. Un retour qui aurait
 * devine renvoyait un administrateur du back-office sur le portail client.
 *
 * Les DEUX appelants nomment donc leur origine, `?from=client-hub` et `?from=hub-admin`,
 * une ligne chacun. Ce fichier est le seul lecteur de ce parametre : la valeur voyage, elle
 * ne se deduit pas.
 *
 * **Le defaut est le PORTAIL**, ce que fait deja `goToApp` apres la connexion : un signet
 * ou un vieil onglet arrive ici sans parametre, et le portail est la destination de la
 * grande majorite. Un administrateur qui suit ce defaut atterrit sur le portail, ou PCG-118
 * l'accepte, plutot que devant un lien absent.
 */
export const useReturnTarget = (): ReturnTarget => {
    const [searchParams] = useSearchParams();
    const isBackOffice = searchParams.get('from') === 'hub-admin';

    return {
        href: appUrl(isBackOffice ? AppName.CLIENT_BO : AppName.PORTAIL_CLIENT),
        label: isBackOffice ? c('Account back').t`Back to the back-office` : c('Account back').t`Back to the portal`,
    };
};
